<script setup lang="ts">
import { formatFriendlyTime } from '@/utils/time'
import { currentLang } from '@/composables/settings/storage'
import { isNotEmpty } from '@/utils/util'
import { minifyString, MAX_NAME_CHARS } from '@/utils/util'
import type { PropType } from 'vue'
import type { FileDTO } from '@/composables/media/media'
import type { WechatUserInfo } from '@/composables/user/users'

const {
  avatar,
  wechatInfo,
  fullName,
  relationName,
  hideAvatar,
  textTight,
  displayTime,
  suffix,
  smallName,
  loose,
  nameLimit
} = defineProps({
  avatar: {
    type: Object as PropType<FileDTO | null>,
    default: null
  },
  wechatInfo: {
    type: Object as PropType<WechatUserInfo | null>,
    default: null
  },
  fullName: {
    type: String,
    required: true,
    default: ''
  },
  relationName: {
    type: String,
    required: false,
    default: ''
  },
  hideAvatar: {
    type: Boolean,
    required: false,
    default: false
  },
  textTight: {
    type: Boolean,
    required: false,
    default: false
  },
  displayTime: {
    type: Number,
    required: false,
    default: 0
  },
  suffix: {
    type: String,
    required: false,
    default: ''
  },
  smallName: {
    type: Boolean,
    required: false,
    default: false
  },
  loose: {
    type: Boolean,
    required: false,
    default: false
  },
  nameLimit: {
    type: Number,
    required: false,
    default: 20
  }
})
</script>
<template>
  <div w-full flex="~ row" items-center :class="textTight ? 'tracking-tight' : 'tracking-normal'">
    <UserAvatar v-if="!hideAvatar" :avatar="avatar" :wechatInfo="wechatInfo" :circle="true" :size="8" mr-2.8 />
    <div flex="~ col" grow>
      <div flex="~ row" items-baseline text-sm>
        <span max-w-28 truncate text-theme-dark :class="smallName ? 'text-xs max-w-18' : ''">{{
          minifyString(fullName, nameLimit)
        }}</span>
        <span
          :class="[textTight ? 'ml-0.5' : 'ml-2']"
          grow
          text-xs
          truncate
          v-if="isNotEmpty(relationName)"
          min-w-12
          text-theme-gray
          >{{ relationName }}</span
        >
      </div>
      <span text-theme-gray :class="loose ? 'mt-1' : 'mt-0.5'" text-xs truncate max-w-90>{{
        formatFriendlyTime(displayTime, currentLang || 'zh_CN') + suffix
      }}</span>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
